import { render, staticRenderFns } from "./ProfilePasswordChangeForm.vue?vue&type=template&id=6fcd4994&"
import script from "./ProfilePasswordChangeForm.vue?vue&type=script&lang=js&"
export * from "./ProfilePasswordChangeForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePasswordChangeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports